import { call } from '@packages/functions';
import { useCallback, useEffect } from 'react';

export const useResize = (callback: any, data?: () => any) => {
    const handler = useCallback((e: any) => call(callback, e, call(data)), [data, callback]);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            window.addEventListener('resize', handler, { passive: true });
            setTimeout(() => {
                window.dispatchEvent(new Event('resize'));
            });
        }

        return () => {
            if (typeof window !== 'undefined') {
                window.removeEventListener('resize', handler);
            }
        };
    }, ['']);
};
